let BTFreBought = {
	selectors: {
		selectedClass: 'selected',
		checkbox: '.pg__fre-check',
		variantSelect: '.fre-variant-id',
		pItem: '.pg',
		frebItem: '.freb__item',
		frebItemImage: '.freb__item__image',
		frebMainImage: '.freb__main-image',
		frebMainImageWrap: '.freb__main-image-wrap',
		totalPrice: '.freb__total-price',
		addBtn: '.freb__add-btn',
		wrap: '.fre-bought',
		requiredClass: 'pg__option--required'
	},

	updateTotalBox: function(wrap) {
		let price = 0;
		let comparePrice = 0;
		let count = 0;
		wrap.find('.' + this.selectors.requiredClass).removeClass(this.selectors.requiredClass);
		wrap.find(this.selectors.pItem + '.' + this.selectors.selectedClass).each((index, pItemEle) => {
			const select = $(pItemEle).find(this.selectors.variantSelect).first();
			if(select.val()) {
				const option = select.find('option:selected');
				price += parseInt(option.data('price'));
				comparePrice += parseInt(option.data('compare-price'));
				count++;
			} else {
				select.addClass(this.selectors.requiredClass);
			}
		});
		wrap.find(this.selectors.totalPrice).html(this.getTotalPriceHtml(price, comparePrice));
		if(count > 0) {
			wrap.find(this.selectors.addBtn).removeAttr('disabled');
		} else {
			wrap.find(this.selectors.addBtn).attr('disabled', 'disabled');
		}
		BT.convertCurrencySilence(wrap.find('span.money'));
	},

	getTotalPriceHtml: function(price, comparePrice) {
    var priceHtml = '';
    if(comparePrice > price) {
    	priceHtml += '<span class="product-price__price product-price__price--freb">' + BT.getPriceHtml(price) + '</span>';
      priceHtml += '<s class="product-price__price product-price__price--freb product-price__sale">' + BT.getPriceHtml(comparePrice) + '</s>';      
    } else {
      priceHtml += '<span class="product-price__price product-price__price--freb">' + BT.getPriceHtml(price) + '</span>';
    }
    return priceHtml;
  },

  init: function() {
  	const selector = this.selectors;
		$(selector.checkbox).unbind('click');
		$(selector.checkbox).on('click', (e) => {
			e.preventDefault();
			$(e.currentTarget).closest(this.selectors.pItem).toggleClass(this.selectors.selectedClass);
			this.updateTotalBox($(e.currentTarget).closest(this.selectors.wrap));
		});
		$(selector.variantSelect).unbind('change');
		$(selector.variantSelect).on('change', (e) => {
			const select = $(e.currentTarget);
			const pg = select.closest(selector.pItem);
			const option = select.children('option:selected');
			pg.find(BT.selectors.productGroup.price).html(BT.getPriceTagHtml(parseInt(option.data('price')), parseInt(option.data('compare-price'))));
			if(option.data('featured-image') != undefined) {
				BT.changeMainImage(pg, option.data('featured-image'));
			}
			this.updateTotalBox(select.closest(this.selectors.wrap));	
		});
		$(selector.addBtn).unbind('click');
		$(selector.addBtn).on('click', (e) => {
			const btn = $(e.currentTarget);
			const wrap = btn.closest(this.selectors.wrap);
			let params = [];
			const selectedItems = wrap.find(this.selectors.pItem + '.' + this.selectors.selectedClass);
			selectedItems.each((indexSelect, selectEle) => {
				const select = $(selectEle);
				const option = select.find(this.selectors.variantSelect + ' option:selected');
				const variantId = option.attr('value');
				params.push({id: variantId, quantity: 1});
			});
			BT.showLoadingFull();

			BT.callAjax(theme.cartAddUrl, 'post', {items: params}, 'json', () => {
  			document.location.href = theme.cartUrl;
  		});
		});
		$(document).on('change', this.selectors.qtyBox, (e) => {
			this.updateTotalBox($(e.currentTarget).closest(this.selectors.wrap));
		});
	}
}